// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"dual-fuel-smart-generator_productcontent__izRYy"};